import { AxiosResponse } from 'axios';
import { get } from 'lodash';

export type IResponseDataBody<DataModel = any> = AxiosResponse<{
  status: number;
  message: string;
  data: DataModel;
}>;

export interface IBodyApiUpdateStatusApt {
  appointmentId: string;
  status: number;
  reason: string;
}

export const getMessageError = (error: any, fallbackString = 'Request failed') =>
  get(error, ['response', 'data', 'message'], fallbackString) || fallbackString;

export type IResponseTableDataBody<T> = AxiosResponse<{
  status: number;
  message: string;
  data: IResponseTableData<T>;
}>;

export interface IResponseTableData<T> {
  content: T[];
  pageable: IPageableTable;
  totalElements: number;
  totalPages: number;
  last: boolean;
  size: number;
  number: number;
  sort: ISortTable;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}
export interface IPageableTable {
  sort: ISortTable;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface ISortTable {
  sorted: boolean;
  empty: boolean;
  unsorted: boolean;
}
